import { request, isMockMode, mockResponse } from './client.js';

/**
 * 會員自助：個人資料 / 密碼 / 收貨地址（owner-scoped，需登入）。
 * REACT_APP_USE_MOCK_ACCOUNT=false 走真實後端。
 */

// ── 個人資料 ──────────────────────────────────────────────
export function updateProfile(payload) {
  if (!isMockMode('account')) return request('/api/me', { method: 'PATCH', body: payload });
  return mockResponse(() => ({ ...payload }));
}

export function changePassword(payload) {
  if (!isMockMode('account')) return request('/api/me/password', { method: 'POST', body: payload });
  return mockResponse(() => null);
}

// ── 收貨地址簿 ────────────────────────────────────────────
let _addrs = [];
let _nextId = 1;
const clone = (x) => JSON.parse(JSON.stringify(x));

export function getAddresses() {
  if (!isMockMode('account')) return request('/api/addresses');
  return mockResponse(() => _addrs.map(clone));
}

export function createAddress(payload) {
  if (!isMockMode('account')) return request('/api/addresses', { method: 'POST', body: payload });
  return mockResponse(() => {
    const a = { id: _nextId++, ...payload, isDefault: payload.isDefault || _addrs.length === 0 };
    if (a.isDefault) _addrs.forEach(x => { x.isDefault = false; });
    _addrs = [a, ..._addrs];
    return clone(a);
  });
}

export function updateAddress(id, payload) {
  if (!isMockMode('account')) return request(`/api/addresses/${id}`, { method: 'PUT', body: payload });
  return mockResponse(() => {
    const idx = _addrs.findIndex(a => a.id === id);
    if (idx === -1) throw new Error('找不到該地址');
    if (payload.isDefault) _addrs.forEach(x => { x.isDefault = false; });
    _addrs[idx] = { ..._addrs[idx], ...payload };
    return clone(_addrs[idx]);
  });
}

export function setDefaultAddress(id) {
  if (!isMockMode('account')) return request(`/api/addresses/${id}/default`, { method: 'PATCH' });
  return mockResponse(() => {
    _addrs.forEach(a => { a.isDefault = a.id === id; });
    return clone(_addrs.find(a => a.id === id));
  });
}

export function deleteAddress(id) {
  if (!isMockMode('account')) return request(`/api/addresses/${id}`, { method: 'DELETE' });
  return mockResponse(() => { _addrs = _addrs.filter(a => a.id !== id); return null; });
}

// ── 紅利點數 ──────────────────────────────────────────────
// 回傳 { balance, expireAt, transactions:[{date,label,delta,type}] }
export function getPoints() {
  if (!isMockMode('account')) return request('/api/me/points');
  return mockResponse(() => ({ balance: 0, expireAt: null, transactions: [] }));
}
